/** Client-side mirror of backend schedule date math (40-hr week, staff capacity). */

const HOURS_PER_DAY = 8;

function parseYmd(ymd) {
  if (!ymd) return null;
  const s = String(ymd).trim().split('T')[0];
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return null;
  const [y, m, d] = s.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  return Number.isNaN(date.getTime()) ? null : date;
}

function formatYmd(date) {
  if (!date || Number.isNaN(date.getTime())) return null;
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

function isBusinessDay(date) {
  const day = date.getDay();
  return day >= 1 && day <= 5;
}

function addCalendarDays(date, days) {
  const next = new Date(date.getTime());
  next.setDate(next.getDate() + days);
  return next;
}

export function normalizeStaffCount(value) {
  const n = parseInt(String(value ?? ''), 10);
  return Number.isFinite(n) && n >= 1 ? n : 1;
}

export function addBusinessHours(startYmd, totalHours, staffCount = 1) {
  const hours = Number(totalHours);
  if (!startYmd || !Number.isFinite(hours) || hours <= 0) return null;
  const hoursPerDay = HOURS_PER_DAY * normalizeStaffCount(staffCount);

  let remaining = hours;
  let current = parseYmd(startYmd);
  if (!current) return null;

  let guard = 0;
  while (remaining > 0 && guard < 5000) {
    guard += 1;
    if (isBusinessDay(current)) {
      remaining -= hoursPerDay;
      if (remaining <= 0) break;
    }
    current = addCalendarDays(current, 1);
  }

  return formatYmd(current);
}
